/* eslint-disable @harmony/stencil/no-tailwind-disable */
/* eslint-disable tailwindcss/no-custom-classname */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
// eslint-disable-next-line @harmony/stencil/no-import-css
import './AssistantLoader.scss';

export const AssistantLoader = ({ align = 'left' }) => {
  const loaderWrapperClasses = classnames('assistant-loader-wrapper sui-flex sui-px-3 sui-py-4 sui-gap-3', {
    'sui-justify-start': align === 'left',
    'sui-justify-center': align === 'center',
    'sui-justify-end': align === 'right',
  });
  const dotClasses = 'sui-rounded-full';

  return (
    <div className={loaderWrapperClasses}>
      <span className={dotClasses} />
      <span className={dotClasses} />
      <span className={dotClasses} />
    </div>
  );
};

AssistantLoader.propTypes = {
  align: PropTypes.oneOf(['left', 'center', 'right']),
};

AssistantLoader.defaultProps = {
  align: 'left',
};

AssistantLoader.displayName = 'AssistantLoader';
